import { Injectable } from '@angular/core';
import { Router, RouterEvent, NavigationEnd } from '@angular/router';

import { map, mapTo, filter, withLatestFrom } from 'rxjs/operators';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { ROUTER_NAVIGATION, RouterReducerState } from '@ngrx/router-store';

import { RouterStateUrl } from '@sd-portal/shared/util';

import { State } from '.';
import * as actions from './shared-audit.actions';
import { AuditScreen } from '../audit-screen.enum';

@Injectable()
export class SharedAuditEffects {
  constructor(
    private readonly actions$: Actions,
    private readonly router: Router,
    private readonly store: Store<{
      router: RouterReducerState<RouterStateUrl>;
      sharedAudit: State;
    }>
  ) {}

  routerNavigation$ = createEffect(() =>
    this.actions$.pipe(ofType(ROUTER_NAVIGATION), mapTo(actions.HideAuditDrawer()))
  );

  /**
   * HACK: proper router-store event timining not availale outside night-builds yet
   * https://github.com/ngrx/platform/blob/master/docs/router-store/api.md#navigation-action-timing
   * NOTE: implementation based of concepts introduced with 'navigation-action-timing`
   * https://github.com/ngrx/platform/blob/master/modules/router-store/src/router_store_module.ts
   */
  enableAudit$ = createEffect(() =>
    this.router.events.pipe(
      filter(event => event instanceof RouterEvent),
      filter(event => event instanceof NavigationEnd),
      withLatestFrom(this.store),
      map(([_event, store]) => {
        const r = store.router;
        if (!r || !r.state || !r.state.data) {
          return actions.DisableAudit();
        }
        const routerStateData = r.state.data;
        const enableAudit = routerStateData['enableAudit'];
        if (enableAudit) {
          const auditScreen = routerStateData['auditScreen'] as AuditScreen | null;
          const auditScreens = routerStateData['auditScreens'] as AuditScreen[] | null;
          return actions.EnableAudit({ auditScreen, auditScreens });
        }
        return actions.DisableAudit();
      })
    )
  );
}
